// extracted by mini-css-extract-plugin
export default {"searchContainer":"adminSearch_searchContainer__keNJd","searchIcon":"adminSearch_searchIcon__sR6ty","searchInput":"adminSearch_searchInput__Wx8qx"};